import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import _classCallCheck from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/labeledinput/labeledinputview
 */
import View from '../view';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
import LabelView from '../label/labelview';
import '../../theme/components/labeledinput/labeledinput.css';
/**
 * The labeled input view class.
 *
 * @extends module:ui/view~View
 */

var LabeledInputView = /*#__PURE__*/function (_View) {
  _inherits(LabeledInputView, _View);

  var _super = _createSuper(LabeledInputView);

  /**
   * Creates an instance of the labeled input view class.
   *
   * @param {module:utils/locale~Locale} locale The locale instance.
   * @param {Function} InputView Constructor of the input view.
   */
  function LabeledInputView(locale, InputView) {
    var _this;

    _classCallCheck(this, LabeledInputView);

    _this = _super.call(this, locale);
    var inputUid = "ck-input-".concat(uid());
    var statusUid = "ck-status-".concat(uid());
    /**
     * The text of the label.
     *
     * @observable
     * @member {String} #label
     */

    _this.set('label');
    /**
     * The value of the input.
     *
     * @observable
     * @member {String} #value
     */


    _this.set('value');
    /**
     * Controls whether the component is in read-only mode.
     *
     * @observable
     * @member {Boolean} #isReadOnly
     */


    _this.set('isReadOnly', false);
    /**
     * The validation error text. When set, it will be displayed
     * next to the {@link #inputView} as a typical validation error message.
     * Set it to `null` to hide the message.
     *
     * **Note:** Setting this property to anything but `null` will automatically
     * make the {@link module:ui/inputtext/inputtextview~InputTextView#hasError `hasError`}
     * of the {@link #inputView} `true`.
     *
     * **Note:** Typing in the {@link #inputView} which fires the
     * {@link module:ui/inputtext/inputtextview~InputTextView#event:input `input` event}
     * resets this property back to `null`, indicating that the input field can be re–validated.
     *
     * @observable
     * @member {String|null} #errorText
     */


    _this.set('errorText', null);
    /**
     * The additional information text displayed next to the {@link #inputView} which can
     * be used to inform the user about the purpose of the input, provide help or hints.
     *
     * Set it to `null` to hide the message.
     *
     * **Note:** This text will be displayed in the same place as {@link #errorText} but the
     * latter always takes precedence: if the {@link #errorText} is set, it replaces
     * {@link #errorText} for as long as the value of the input is invalid.
     *
     * @observable
     * @member {String|null} #infoText
     */


    _this.set('infoText', null);
    /**
     * The label view.
     *
     * @member {module:ui/label/labelview~LabelView} #labelView
     */


    _this.labelView = _this._createLabelView(inputUid);
    /**
     * The input view.
     *
     * @member {module:ui/inputtext/inputtextview~InputTextView} #inputView
     */

    _this.inputView = _this._createInputView(InputView, inputUid, statusUid);
    /**
     * The status view for the {@link #inputView}. It displays {@link #errorText} and
     * {@link #infoText}.
     *
     * @member {module:ui/view~View} #statusView
     */

    _this.statusView = _this._createStatusView(statusUid);
    /**
     * The combined status text made of {@link #errorText} and {@link #infoText}.
     * Note that when present, {@link #errorText} always takes precedence in the
     * status.
     *
     * @see #errorText
     * @see #infoText
     * @see #statusView
     * @private
     * @observable
     * @member {String|null} #_statusText
     */

    _this.bind('_statusText').to(_assertThisInitialized(_this), 'errorText', _assertThisInitialized(_this), 'infoText', function (errorText, infoText) {
      return errorText || infoText;
    });

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck', 'ck-labeled-input', bind.if('isReadOnly', 'ck-disabled')]
      },
      children: [_this.labelView, _this.inputView, _this.statusView]
    });

    return _this;
  }
  /**
   * Creates label view class instance and bind with view.
   *
   * @private
   * @param {String} id Unique id to set as labelView#for attribute.
   * @returns {module:ui/label/labelview~LabelView}
   */


  _createClass(LabeledInputView, [{
    key: "_createLabelView",
    value: function _createLabelView(id) {
      var labelView = new LabelView(this.locale);
      labelView.for = id;
      labelView.bind('text').to(this, 'label');
      return labelView;
    }
    /**
     * Creates input view class instance and bind with view.
     *
     * @private
     * @param {Function} InputView Input view constructor.
     * @param {String} inputUid Unique id to set as inputView#id attribute.
     * @param {String} statusUid Unique id of the status for the input's `aria-describedby` attribute.
     * @returns {module:ui/inputtext/inputtextview~InputTextView}
     */

  }, {
    key: "_createInputView",
    value: function _createInputView(InputView, inputUid, statusUid) {
      var _this2 = this;

      var inputView = new InputView(this.locale, statusUid);
      inputView.id = inputUid;
      inputView.ariaDescribedById = statusUid;
      inputView.bind('value').to(this);
      inputView.bind('isReadOnly').to(this);
      inputView.bind('hasError').to(this, 'errorText', function (value) {
        return !!value;
      });
      inputView.on('input', function () {
        // UX: Make the error text disappear and disable the error indicator as the user
        // starts fixing the errors.
        _this2.errorText = null;
      });
      return inputView;
    }
    /**
     * Creates the status view instance. It displays {@link #errorText} and {@link #infoText}
     * next to the {@link #inputView}. See {@link #_statusText}.
     *
     * @private
     * @param {String} statusUid Unique id of the status, shared with the input's `aria-describedby` attribute.
     * @returns {module:ui/view~View}
     */

  }, {
    key: "_createStatusView",
    value: function _createStatusView(statusUid) {
      var statusView = new View(this.locale);
      var bind = this.bindTemplate;
      statusView.setTemplate({
        tag: 'div',
        attributes: {
          class: ['ck', 'ck-labeled-input__status', bind.if('errorText', 'ck-labeled-input__status_error'), bind.if('_statusText', 'ck-hidden', function (value) {
            return !value;
          })],
          id: statusUid,
          role: bind.if('errorText', 'alert')
        },
        children: [{
          text: bind.to('_statusText')
        }]
      });
      return statusView;
    }
    /**
     * Moves the focus to the input and selects the value.
     */

  }, {
    key: "select",
    value: function select() {
      this.inputView.select();
    }
    /**
     * Focuses the input.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.inputView.focus();
    }
  }]);

  return LabeledInputView;
}(View);

export { LabeledInputView as default };